import { useEffect } from 'react';
/**
 * This just adds the page class to the body.
 * @param pageType the type of page
 */
function usePageClassName(pageType) {
    useEffect(() => {
        document.body.classList.remove('article-page', 'category-page', 'index-page', 'generic-page', 'search-page', 'error-page');
        document.body.classList.add(pageType);
    }, [pageType]);
}
export default usePageClassName;
//# sourceMappingURL=usePageClassName.js.map